<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;"  label="模糊查询：">
        <el-input v-model="dataForm.key" placeholder="操作用户/内容" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button type="success" @click="logExcel()">导出Excel</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)"
      border stripe :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="日志ID">
      </el-table-column>
      <el-table-column
        prop="username"
        header-align="center"
        align="center"
        label="操作用户">
      </el-table-column>
      <el-table-column
        prop="operation"
        header-align="center"
        align="center"
        label="操作内容">
      </el-table-column>
      <el-table-column
        prop="time"
        header-align="center"
        align="center"
        label="耗时">
      </el-table-column>
      <el-table-column
        prop="method"
        header-align="center"
        align="center"
        label="操作方法"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="params"
        header-align="center"
        align="center"
        label="方法参数"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="ip"
        header-align="center"
        align="center"
        label="操作者IP">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间"
        sortable>
      </el-table-column>
      <el-table-column
        prop="location"
        header-align="center"
        align="center"
        label="操作地点"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">
            <i class="el-icon-delete" style="font-size: 18px;"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import {excel} from "@/utils"

export default {
  data() {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 100,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/log/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'params': this.dataForm.key
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/log/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //导出excel
    logExcel() {
      excel("/log/excel", "操作日志信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'params': this.dataForm.key
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/log.vue